// native
import { Injectable } from '@angular/core';

// addon
import * as clipboard from 'clipboard-polyfill';

// service
import { ToastService } from './toast.service';
import { UtilityService } from './utility.service';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  constructor(
    private toastService: ToastService,
    private utilityService: UtilityService
  ) { }

  copyToClipboard(text: string | string[], html?: string) {
    text = Array.isArray(text) ? text.join(', ') : text;

    // in windows edge ClipboardItem doesn't work
    if (this.utilityService.isOldEdge) {
      clipboard.writeText(text).catch(() => {
        this.toastService.openToast({
          text: 'There was an error while copying to clipboard',
          type: 'error'
        });
      });

      return;
    }

    const item = new clipboard.ClipboardItem({
      'text/html': new Blob([html || text], { type: 'text/html' }),
      'text/plain': new Blob([text], { type: 'text/plain' }),
    });

    clipboard.write([item]).catch(() => {
      this.toastService.openToast({
        text: 'There was an error while copying to clipboard',
        type: 'error'
      });
    });
  }
}